<template>
    <div id="vue-body">
        <hr>
        <div class="h5">Opis:</div>
        <div v-for="(section,index) in sections">
            <input :name="'description_id[' + index + ']'" type="hidden" v-model="section.id"></input>
            <div class="h3 text-center mb-3" style="background: #2C3E50; color: #fff;">
                Sekcja {{ index + 1 }}:
                <button class="btn btn-sm btn-info" type="button" v-if="index != 0" @click="swapUP(index)"><i class="fa fa-chevron-up"></i></button>
                <button class="btn btn-sm btn-info" type="button" v-if="index != sections.length - 1" @click="swapDown(index)"><i class="fa fa-chevron-down"></i></button>
                <button class="btn btn-sm btn-danger" type="button" @click="remove(index)"><i class="fa fa-times"></i></button>
            </div>
            <div class="form-group row align-items-center">
                <label :for="'type-' + index" class="col-md-4 col-form-label text-md-right">Styl sekcji:</label>
                <div class="col-md-8">
                    <select :name="'description_type[' + index + ']'" v-model="section.type" class="form-control" :id="'type-' + index" @change="changeType">
                        <option v-for="(section_type, i) in section_types" :value="i">{{ section_type.name }}</option>
                    </select>
                </div>
            </div>

            <div class="col-md-8 offset-md-4 my-2">
                <img :src="'/images/descriptionSections/section-' + section.type + '.jpg'" style="border:1px solid #000; max-width: 600px;">
            </div>
            <div class="form-group row align-items-center" v-if="section_types && section_types[section.type].fields.includes('title')">
                <label :for="'title-' + index" class="col-md-4 col-form-label text-md-right">Tytuł</label>
                <div class="col-md-8">
                    <input :name="'description_title[' + index + ']'" :id="'title-' + index" class="form-control" v-model="section.title"></input>
                </div>
            </div>

            <div class="form-group row align-items-center" v-if="section_types && section_types[section.type].fields.includes('text')">
                <label :for="'description-' + index" class="col-md-4 col-form-label text-md-right">Treść</label>
                <div class="col-md-8">
                    <textarea :name="'description_text[' + index + ']'" :id="'description-' + index" v-model="section.text"></textarea>
                </div>
            </div>

            <div class="form-group row align-items-center" v-if="section_types && section_types[section.type].fields.includes('text2')">
                <label :for="'description2-' + index" class="col-md-4 col-form-label text-md-right">Tekst 2</label>
                <div class="col-md-8">
                    <textarea :name="'description_text2[' + index + ']'" :id="'description2-' + index" v-model="section.text2"></textarea>
                </div>
            </div>

            <div class="form-group row align-items-center" v-if="section_types && section_types[section.type].fields.includes('text3')">
                <label :for="'description3-' + index" class="col-md-4 col-form-label text-md-right">Tekst 3</label>
                <div class="col-md-8">
                    <textarea :name="'description_text3[' + index + ']'" :id="'description3-' + index" v-model="section.text3"></textarea>
                </div>
            </div>

            <div class="form-group row align-items-center" v-if="section_types && section_types[section.type].fields.includes('image')">
                <label :for="'image-' + index" class="col-md-4 col-form-label text-md-right">Grafika</label>
                <div class="col-md-8">
                    <input :name="'description_image[' + index + ']'" type='file' :id="'image-' + index" class='form-control'></input>
                </div>
            </div>

            <div class="form-group row align-items-center" v-if="section_types && section_types[section.type].fields.includes('button1_text')">
                <label :for="'button1_text-' + index" class="col-md-4 col-form-label text-md-right">Guzik 1 tekst:</label>
                <div class="col-md-8">
                    <input :name="'description_button1_text[' + index + ']'" :id="'button1_text-' + index" class="form-control" v-model="section.button1_text"></input>
                </div>
            </div>

            <div class="form-group row align-items-center" v-if="section_types && section_types[section.type].fields.includes('button1_link')">
                <label :for="'button1_link-' + index" class="col-md-4 col-form-label text-md-right">Guzik 1 link:</label>
                <div class="col-md-8">
                    <input :name="'description_button1_link[' + index + ']'" :id="'button1_link-' + index" class="form-control" v-model="section.button1_link"></input>
                </div>
            </div>

            <div class="form-group row align-items-center" v-if="section_types && section_types[section.type].fields.includes('button1_new_tab')">
                <div class="col-md-8 offset-md-4">
                    <div class="form-check">
                        <input :id="'button1_new_tab-' + index"
                            :name="'description_button1_new_tab[' + index + ']'"
                            type="checkbox" value="1" class="form-check-input"
                            :checked="section.button1_new_tab">
                        <label :for="'button1_new_tab-' + index" class="form-check-label">
                            Guzik 1 otwórz w nowej karcie
                        </label>
                    </div>
                </div>
            </div>

            <div class="form-group row align-items-center" v-if="section_types && section_types[section.type].fields.includes('button2_text')">
                <label :for="'button2_text-' + index" class="col-md-4 col-form-label text-md-right">Guzik 2 tekst:</label>
                <div class="col-md-8">
                    <input :name="'description_button2_text[' + index + ']'" :id="'button2_text-' + index" class="form-control" v-model="section.button2_text"></input>
                </div>
            </div>

            <div class="form-group row align-items-center" v-if="section_types && section_types[section.type].fields.includes('button2_link')">
                <label :for="'button2_link-' + index" class="col-md-4 col-form-label text-md-right">Guzik 2 link:</label>
                <div class="col-md-8">
                    <input :name="'description_button2_link[' + index + ']'" :id="'button2_link-' + index" class="form-control" v-model="section.button2_link"></input>
                </div>
            </div>

            <div class="form-group row align-items-center" v-if="section_types && section_types[section.type].fields.includes('button2_new_tab')">
                <div class="col-md-8 offset-md-4">
                    <div class="form-check">
                        <input :id="'button2_new_tab-' + index"
                            :name="'description_button2_new_tab[' + index + ']'"
                            type="checkbox" value="1" class="form-check-input"
                            :checked="section.button2_new_tab">
                        <label :for="'button2_new_tab-' + index" class="form-check-label">
                            Guzik 2 otwórz w nowej karcie
                        </label>
                    </div>
                </div>
            </div>

            <div class="form-group row align-items-center" v-if="section_types && section_types[section.type].fields.includes('program_id')">
                <label :for="'program_id-' + index" class="col-md-4 col-form-label text-md-right">Program:</label>
                <div class="col-md-8">
                    <select :name="'description_program_id[' + index + ']'" :id="'program_id-' + index" class="form-control" v-model="section.program_id">
                        <option v-for="(program, i) in programs" :value="i">{{ program }}</option>
                    </select>
                </div>
            </div>

            <div v-if="section_types && (section_types[section.type].fields.includes('numbers') || section_types[section.type].fields.includes('texts'))">
                <div class="row align-items-center form-group" v-for="number in section.numbers">
                    <label :for="'program_id-' + index" class="col-md-4 col-form-label text-md-right" v-if="section_types[section.type].fields.includes('numbers')">Liczba:</label>
                    <div class="col-md-8" v-if="section_types[section.type].fields.includes('numbers')">
                        <input :name="'description_numbers[' + index + '][]'" type="number" :id="'program_id-' + index" class="form-control" v-model="number.number" />
                    </div>
                    <label :for="'program_id-' + index" class="col-md-4 col-form-label text-md-right">Tekst:</label>
                    <div class="col-md-8">
                        <input :name="'description_numbers_text[' + index + '][]'" type="text" :id="'program_id-' + index" class="form-control" v-model="number.name" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-8 offset-md-4">
                        <div class="btn btn-success" @click="add_number(section)">
                            Dodaj kafelek
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="section_types && section_types[section.type].fields.includes('testimonials')">
                <div class="row">
                    <div class="col-6 col-md-4" v-for="testimonial in testimonials">
                        <div class="form-check">
                            <input :id="'testimonial-' + index + '-' + testimonial.id"
                                :name="'description_testimonials[' + index + '][]'"
                                type="checkbox" :value="testimonial.id" class="form-check-input"
                                :checked="section.testimonials_ids[testimonial.id]">
                            <label :for="'testimonial-' + index + '-' + testimonial.id" class="form-check-label">
                                {{ testimonial.name }}<br>
                                <span style="font-size: 0.9em;">{{ testimonial.position }}</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group row align-items-center" v-if="section_types && section_types[section.type].fields.includes('author')">
                <label :for="'author_id-' + index" class="col-md-4 col-form-label text-md-right">Redaktor naczelny:</label>
                <div class="col-md-8">
                    <select :name="'description_author_id[' + index + ']'" :id="'author_id-' + index" class="form-control" v-model="section.author_id">
                        <option value="0">--brak--</option>
                        <option v-for="author in authors" :value="author.id">{{ author.name }} {{ author.surname }}</option>
                    </select>
                </div>
            </div>

            <div v-if="section_types && section_types[section.type].fields.includes('authors')">
                W pole obok zaznaczonego autora wpisz liczbę która będzie odpowiadała za kolejność wyświetlania (im większa tym wyżej wyświetlany)
                <div class="row">
                    <div class="col-12 col-md-6" v-for="author in authors">
                        <div class="row">
                            <div class="col-6">
                                <div class="form-check">
                                    <input :id="'authors-' + index + '-' + author.id"
                                        :name="'description_authors[' + index + '][]'"
                                        type="checkbox" :value="author.id" class="form-check-input"
                                        :checked="section.authors_ids[author.id] !== undefined">
                                    <label :for="'authors-' + index + '-' + author.id" class="form-check-label">
                                    {{ author.name }} {{ author.surname }}
                                    </label>
                                </div>
                            </div>
                            <div class="col-6">
                                <input class="form-control" :name="'description_authors_order[' + index + '][' + author.id + ']'" :value="section.authors_ids[author.id] ? section.authors_ids[author.id] : 0" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="section_types && section_types[section.type].fields.includes('programs')">
                <div class="row">
                    <div class="col-6 col-md-4" v-for="(program, i) in programs">
                        <div class="form-check">
                            <input :id="'programs-' + index + '-' + i"
                                :name="'description_programs[' + index + '][]'"
                                type="checkbox" :value="i" class="form-check-input"
                                :checked="section.programs_ids[i]">
                            <label :for="'programs-' + index + '-' + i" class="form-check-label">
                                {{ program }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="section_types && section_types[section.type].fields.includes('videos')">
                <div class="h5">Wybierz kategorie webinarów:</div>
                <select :name="'description_video_category_id[' + index + ']'" :id="'video_category_id-' + index" class="form-control" v-model="section.video_category_id">
                    <option value="0">--brak--</option>
                    <option v-for="video_category in video_categories" :value="video_category.id">{{ video_category.name }}</option>
                </select>
                <hr>
                <div class="h5">Lub wybierz webinary</div>
                <div class="row">
                    <div class="col-6 col-md-4" v-for="video in videos">
                        <div class="form-check">
                            <input :id="'videos-' + index + '-' + video.id"
                                :name="'description_videos[' + index + '][]'"
                                type="checkbox" :value="video.id" class="form-check-input"
                                :checked="section.videos_ids[video.id]">
                            <label :for="'videos-' + index + '-' + video.id" class="form-check-label">
                                {{ video.name }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            
            <div v-if="section_types && section_types[section.type].fields.includes('article_id')">
                <div class="row">
                    <label :for="'article_id-' + index" class="col-md-4 col-form-label text-md-right">Wybierz darmowy artykuł <i class="fas fa-info-circle" title="Pamiętaj o zmianie level artykułu, by był dostępny dla wszystkich"></i>:</label>
                    <div class="col-md-8">
                        <input :id="'article_id-' + index" class="form-control" v-model="article_search" @keyup="search_article"/>
                        <div id="article_name">{{ section.article ? section.article.name + "(" + section.article.id + ')' : '' }} <i class="fas fa-times remove-article" style="cursor:pointer;" v-if="section.article"></i></div>
                        <input :name="'description_article_id[' + index + ']'" type="hidden" id="article_id_input" />
                        <div id="search-results"></div>
                    </div>
                </div>
            </div>

            <hr>
        </div>
        <button type="button" class="btn btn-success" @click="add_section()">Dodaj sekcje</button>
        <hr>
    </div>
</template>

<script>

export default {
  mounted() {
    axios.get('/admin/description-types', {}).then(response => {
      this.section_types = response.data;
    });
    axios.post('/admin/articles/get-programs-list', {}).then(response => {
      this.programs = response.data;
    });
    axios.get('/admin/get-testimonials-list', {}).then(response => {
      this.testimonials = response.data;
    });
    axios.get('/admin/get-authors-list', {}).then(response => {
      this.authors = response.data;
    });
    axios.get('/admin/get-videos-list', {}).then(response => {
      this.videos = response.data;
    });
    axios.get('/admin/get-video-categories-list', {}).then(response => {
      this.video_categories = response.data;
    });
    axios.post('/admin/item-description', {id: this.item_id, model: this.item_model}).then(response => {
      this.sections = response.data;
      this.init_tinymce();
    });
  },
  data: function() {
    return {
      sections: [
        {
          title: '',
          text: '',
          type: 0,
          numbers: [{
            number: 0,
            name: ""
          }],
          testimonials_ids: [],
          authors_ids: [],
          programs_ids: [],
          videos_ids: []
        }
      ],
      section_types: false,
      programs: [],
      testimonials: [],
      authors: [],
      videos: [],
      video_categories: [],
      article_search: ""
    }
  },
  props: {
    item_id: false,
    item_model: false
  },
  methods: {
    search_article() {
        $.post("/admin/articles-search", {search: this.article_search, show_form: false, html: true}, function (data) {
            $("#search-results").html(data);
        });
    },
    add_number(section) {
      if(section.numbers.length < 8) {
        section.numbers.push({
          number: 0,
          name: ""
        });
      } else {
        alert("nie można dodać więcej kafelków");
      }
    },
    clear_tinymce() {
      for (var i in this.sections) {
        tinymce.remove('textarea[id="description-' + i + '"]');
        tinymce.remove('textarea[id="description2-' + i + '"]');
        tinymce.remove('textarea[id="description3-' + i + '"]');
      }
    },
    init_tinymce() {
      if (typeof tinymce === 'undefined') {
        setTimeout(this.init_tinymce, 1000);
        return false;
      }
      let self = this;
      this.$nextTick(() => {
        for (var i in self.sections) {
          if (self.section_types[self.sections[i].type].fields.includes('text')) {
            tinymce.init({
              selector:'textarea[id="description-' + i + '"]',
              height: 300,
              plugins: 'code lists',
              toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | numlist bullist | code',
              setup: (editor) => {
                editor.on("change", (e) => {
                  let id = parseInt(editor.id.replace("description-", ""));
                  self.sections[id].text = editor.getContent();
                });
              }
            });
          }
          if (self.section_types[self.sections[i].type].fields.includes('text2')) {
            tinymce.init({
              selector:'textarea[id="description2-' + i + '"]',
              height: 300,
              plugins: 'code lists',
              toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | numlist bullist | code',
              setup: (editor) => {
                editor.on("change", (e) => {
                  let id = parseInt(editor.id.replace("description2-", ""));
                  console.log(id);
                  self.sections[id].text2 = editor.getContent();
                });
              }
            });
          }
          if (self.section_types[self.sections[i].type].fields.includes('text3')) {
            tinymce.init({
              selector:'textarea[id="description3-' + i + '"]',
              height: 300,
              plugins: 'code lists',
              toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | numlist bullist | code',
              setup: (editor) => {
                editor.on("change", (e) => {
                  let id = parseInt(editor.id.replace("description3-", ""));
                  self.sections[id].text3 = editor.getContent();
                });
              }
            });
          }
        }
      });
    },
    changeType() {
      this.clear_tinymce();
      this.$forceUpdate();
      setTimeout(this.init_tinymce, 1000);
    },
    add_section() {
      this.clear_tinymce();
      this.sections.push({
          title: '',
          text: '',
          type: 0,
          numbers: [{
            number: 0,
            name: ""
          }],
          testimonials_ids: [],
          authors_ids: [],
          programs_ids: [],
          videos_ids: []
      });
      this.$forceUpdate();
      this.init_tinymce();
    },
    swapUP(index) {
      this.clear_tinymce();
      let temp = this.sections[index];
      this.sections[index] = this.sections[index - 1];
      this.sections[index - 1] = temp;
      this.$forceUpdate();
      this.init_tinymce();
    },
    swapDown(index) {
      this.clear_tinymce();
      let temp = this.sections[index];
      this.sections[index] = this.sections[parseInt(index) + 1];
      this.sections[parseInt(index) + 1] = temp;
      this.$forceUpdate();
      this.init_tinymce();
    },
    remove(index) {
      this.clear_tinymce();
      this.sections.splice(index, 1);
      this.$forceUpdate();
      this.init_tinymce();
    },
  },
}

$(function () {
    $("#vue-body").on("click", ".btn-pick-article", function () {
        $("#article_name").text($(this).data("name") + "(" + $(this).data("id") + ")");
        $("#article_id_input").val($(this).data("id"));
        $("#search-results").text("");
    });
    $("#vue-body").on("click", ".remove-article", function () {
        $("#article_name").text("");
        $("#article_id_input").val();
        $("#search-results").text("");
    });
})
</script>
